import script from "./RevokeGroupDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./RevokeGroupDialog.vue?vue&type=script&setup=true&lang=ts"

import "./RevokeGroupDialog.vue?vue&type=style&index=0&id=75b7d4a8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75b7d4a8"]])

export default __exports__